import type { MultichoiceControlComponentProps } from '@epilot/journey-logic-commons'
import type { ReactNode } from 'react'

import {
  SuspendedMultipleChoiceButton,
  SuspendedMultipleChoiceCheckbox,
  SuspendedMultipleChoiceImageButton
} from './suspended'

export function MultipleChoiceControl(
  props: MultichoiceControlComponentProps<ReactNode> & {
    IMAGE_PREVIEW_API_URL: string
    isAnimationEffectsEnabled: boolean
  }
) {
  switch (props.uiType) {
    case 'checkbox':
      return <SuspendedMultipleChoiceCheckbox {...(props as any)} />
    case 'imageButton':
      return <SuspendedMultipleChoiceImageButton {...(props as any)} />
    default:
      return <SuspendedMultipleChoiceButton {...(props as any)} />
  }
}
